import React from 'react';
import {
  useBreakpointHelpers,
  useNoticeBannersStackContext,
} from '@sweetgreen/garnish';

import { useLocalizationContext } from '@order/Localization';

import { NoResults as NoResultsDesktop } from './NoResults.desktop';

export const NoResults = ({ noAutocompleteResults = false }) => {
  const { t } = useLocalizationContext();
  const { currentBreakpoint } = useBreakpointHelpers();

  const text = t('location.no-results.banner');
  const message = noAutocompleteResults
    ? t('location.no-autocomplete-result')
    : t('location.no-locations-result');

  const { push: addNoticeBanner } = useNoticeBannersStackContext();

  React.useEffect(() => {
    if (!currentBreakpoint.isMobile) return;
    addNoticeBanner({ text, palette: 'neutral' });
  }, [text, currentBreakpoint.isMobile, addNoticeBanner]);

  if (currentBreakpoint.isMobile) return null;

  return <NoResultsDesktop message={message} />;
};
